const BRAND = "#FF6B35";

interface PaymentFooterProps {
  total: number;
  isCreditApplied?: boolean;
  orderAmount: number;
  onOpenCreditApply?: () => void;
  onPay: () => void;
  paying?: boolean;
}

export function PaymentFooter({ total, isCreditApplied, orderAmount, onOpenCreditApply, onPay, paying }: PaymentFooterProps) {
  const payAmount = total; // isCreditApplied ? orderAmount : total;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white px-4 z-40 space-y-2"
      style={{ borderTop: "1px solid #F5F5F5", paddingTop: "8px", paddingBottom: "calc(8px + env(safe-area-inset-bottom, 0px))" }}
    >
      {/* {!isCreditApplied && (
        <button
          onClick={onOpenCreditApply}
          className="w-full py-3 rounded-2xl text-sm font-semibold cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 active:scale-[0.98] transition-all"
          style={{ background: "#FFF3EE", color: BRAND, border: `1px solid #FFD4BD` }}
        >
          <i className="ri-shield-check-line" style={{ fontSize: 16 }} />获取信用免押
        </button>
      )} */}

      <button
        onClick={onPay}
        disabled={paying}
        className="w-full py-3.5 rounded-2xl text-sm font-semibold text-white cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 active:scale-[0.98] transition-all disabled:opacity-60"
        style={{ background: `linear-gradient(135deg, ${BRAND}, #FF9A5C)` }}
      >
        {paying ? (
          <>
            <i className="ri-loader-4-line spin-icon" style={{ fontSize: 16 }} />
            支付中...
          </>
        ) : (
          <>
            <i className="ri-secure-payment-line" style={{ fontSize: 16 }} />
            确认支付 ¥{payAmount.toLocaleString()}
          </>
        )}
      </button>
      <div className="text-center text-xs text-gray-400">支付即表示同意《服务协议》与《隐私政策》</div>
    </div>
  );
}
